module.exports = __webpack_public_path__ + "img/bg-2.aa46df27.jpg";